import React, { FC } from 'react';

type YouTubeProps = {
  /** The color of the icon. */
  color?: string;
};

const YouTube: FC<YouTubeProps> = ({ color = 'currentColor' }) => (
  <svg
    id="Layer_1"
    version="1.1"
    viewBox="0 0 20 15.4"
    x="0px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    y="0px"
  >
    <g>
      <path
        d="M15.7,1C13,0.8,7,0.8,4.3,1C1.3,1.2,1,3,1,7.6c0,4.7,0.4,6.4,3.3,6.6c2.7,0.2,8.8,0.2,11.5,0 c2.9-0.2,3.3-2,3.3-6.6C19,3,18.7,1.2,15.7,1z M7.7,10.6v-6l6,3L7.7,10.6z"
        fill={color}
      />
    </g>
  </svg>
);

export default YouTube;
